<template>
    <div class="space-y-4">
        <div>
            <p class="text-lg font-bold text-slate-900">Signature par email</p>
        </div>

        <!-- Étapes d'information -->
        <div class="bg-white rounded-2xl border border-gray-200 divide-y divide-gray-100">
            <div v-for="(step, i) in steps" :key="i" class="flex items-start gap-3 px-4 py-3.5">
                <div class="w-6 h-6 rounded-full bg-blue-600 text-white flex items-center justify-center text-xs font-bold shrink-0 mt-0.5">
                    {{ i + 1 }}
                </div>
                <p class="text-sm text-slate-700">{{ step }}</p>
            </div>
        </div>

        <!-- Email destinataire -->
        <div v-if="clientEmail" class="flex items-center gap-3 bg-slate-50 border border-slate-200 rounded-2xl px-4 py-3">
            <svg class="w-4 h-4 text-slate-400 shrink-0" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
                <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/>
                <polyline points="22,6 12,13 2,6"/>
            </svg>
            <div>
                <p class="text-xs text-slate-400 font-medium">Email de destination</p>
                <p class="text-sm font-semibold text-slate-700">{{ clientEmail }}</p>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'StepSignatureEmail',
    inject: ['wm'],

    data() {
        return {
            steps: [
                'Les documents sont générés à la clôture',
                'Un email est envoyé au client avec un lien de signature sécurisé',
                'Le client signe et reçoit ses documents par email',
            ],
        };
    },

    computed: {
        clientEmail() { return this.wm.intervention.client?.email ?? null; },
    },
};
</script>
